/**
 * Shared methods used across components when interacting with the veroFresh
 * REST API
 */
import { isArray, has, get, forEach, indexOf } from 'lodash'

var ApiUtilitiesMixin = {
  methods: {
    /**
     * Render validation errors from entity save.
     * @param error
     */
    renderRecordSaveErrorFlashBanner (error) {
      let output = ''
      const message = get(error, 'response.data.message')
      if (message) {
        output += message + '<br>'
      }

      const responseErrors = get(error, 'response.data.errors')

      if (responseErrors) {
        output += '<ul class="my-0">'
        forEach(responseErrors, field => {
          forEach(field, errorString => {
            output += `<li>${errorString}</li>`
          })
        })
        output += '</ul>'
      }

      if (!output) {
        output = this.$t('network_error_message')
      }
      this.$store.dispatch('globalMessagingModule/showErrorFlashBanner', output)
    },

    /**
     *
     * @param Error error response generated by js-data-http
     */
    renderErrorFlashBanner (error, ignore = []) {
      const errors = []

      // If the response code is one that we explicitly want to silently ignore then exit early
      if (indexOf(ignore, get(error, 'response.status')) !== -1) {
        return
      }

      if (isArray(error.response.data)) {
        error.response.data.forEach(function (error) {
          errors.push(error.message)
        })
      } else {
        errors.push(this.$t('network_error_message'))
      }
      this.$store.dispatch('globalMessagingModule/showErrorFlashBanner', errors.join(', '))
    },

    /**
     * Render error from $httpAdapter, rather than js-data. (Uses a different format)
     * @param error
     * @param array ignore list http status codes to to ignore
     */
    renderHttpAdapterErrorBanner (error, ignore = []) {
      const errors = []

      // If the response code is one that we explicitly want to silently ignore then exit early
      if (indexOf(ignore, get(error, 'response.status')) !== -1) {
        return
      }

      // If the error is of a know type then show the appropriate message
      if (get(error, 'response.status') === 404) {
        errors.push(this.$t('404_error_message'))
      } else if (has(error, 'response.data.message')) {
        // If we don't know the type but the server told us something then show that
        errors.push(error.response.data.message)
      } else {
        // Otherwise just show a generic network error message
        errors.push(this.$t('network_error_message'))
      }

      this.$store.dispatch('globalMessagingModule/showErrorFlashBanner', errors.join(', '))
    },

    /**
     *
     * @param {*} error
     */
    renderErrorModal (error, ignore = []) {
      // If the response code is one that we explicitly want to silently ignore, then exit early
      if (indexOf(ignore, get(error, 'response.status')) !== -1) {
        return
      }

      // Our default message is a generic network error
      let message = this.$t('network_error_message')

      // See if we can refine that based on the error response code
      if (get(error, 'response.status') === 404) {
        message = this.$t('404_error_message')
      }

      this.$store.dispatch('globalMessagingModule/showErrorModal', message)
    }
  }
}

export default ApiUtilitiesMixin
